import { render } from "./App.vue?vue&type=template&id=368b6ad8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "video.js/dist/video-js.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=368b6ad8&lang=scss"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__